// Remembers how each document list was last shown (search, search type,
// status filter, sort, page, rows per page — all kept in the list's URL), so
// coming back from a document opens the list the way the user left it.
// Kept per browser tab (sessionStorage); a new tab starts with the default view.

const storageKey = (listPath) => `listView:${listPath}`;

export function rememberListView(listPath, search) {
    try {
        if (search && search !== "?") sessionStorage.setItem(storageKey(listPath), search);
        else sessionStorage.removeItem(storageKey(listPath));
    } catch {
        // Storage can be blocked (private mode); the list then opens as default.
    }
}

/** The list's address with the view it was last shown in, e.g. "/sales/quotations?search=ABC&page=2". */
export function listReturnPath(listPath) {
    try {
        const search = sessionStorage.getItem(storageKey(listPath));
        if (search) return `${listPath}${search.startsWith("?") ? search : `?${search}`}`;
    } catch {
        // Fall through to the default view.
    }
    return listPath;
}
